import { Injectable, Inject } from '@angular/core';
import {AsyncSubject, BehaviorSubject, Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {filter, map, switchMap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ImmutableListRepositoryService {
  protected lists: AsyncSubject<{[name: string]: any}> = new AsyncSubject();
  protected listsInstant: {[name: string]: any} = {};

  public getLists() {
    return this.lists;
  }
  public ready(): Observable<boolean> {
    return this.lists.pipe(
      map(
        lists => Object.keys(lists).length > 0
      )
    );
  }
  public fetchLists() {
    const url = this.environmentApiBasepoint + 'immutable-list';
    this.httpClient.get(
      url
    ).subscribe(
      (response: Array<{id: string, items: Array<any>}>) => {
        const lists = {};
        response.forEach(
          (responseItem: {id: string, items: Array<any>}) => {
            lists[responseItem.id] = responseItem.items;
          }
        );
        this.lists.next(lists);
        this.lists.complete();
        this.listsInstant = lists;
      }
    );
  }
  public getList(name: string): Observable<Array<{id: any, name: any}>> {
    return this.lists.pipe(
      filter(lists => lists.hasOwnProperty(name)),
      switchMap(lists => [lists[name]])
    );
  }
  public getListInstant(name: string): Array<{id: any, name: any}> {
    return this.listsInstant.hasOwnProperty(name) ? this.listsInstant[name] : [];
  }
  public getItemById(name: string, id: string | number): string {
    const list = this.getListInstant(name);
    const found = list.find((element) => element.id === id);
    return found ? found.name : '';
  }
  constructor(
    protected httpClient: HttpClient,
    @Inject('ENVIRONMENT_VERSION') protected environmentVersion: string,
    @Inject('ENVIRONMENT_API_BASEPOINT') protected environmentApiBasepoint: string
  ) {

  }
}
